import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CheckoutPage } from './pages/CheckoutPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  }
  window.fbq('init', '1288863756546675');
  window.fbq('track', 'PageView');
}
export function App() {
  const [currentPage, setCurrentPage] = useState<'landing' | 'checkout'>('landing');
  useEffect(() => {
    initMetaPixel();
  }, []);
  const goToCheckout = () => {
    setCurrentPage('checkout');
    window.scrollTo(0, 0);
  };
  const goToLanding = () => {
    setCurrentPage('landing');
    window.scrollTo(0, 0);
  };
  if (currentPage === 'checkout') {
    return <CheckoutPage onBack={goToLanding} data-id="element-0" />;
  }
  return <LandingPage onCheckout={goToCheckout} data-id="element-1" />;
}